"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBranchId = exports.getBrand = exports.getCommonConfigValue = void 0;
var env_1 = require("./env");
var constants_1 = require("../constants");
var resolveCommonConfig = function () {
    return (0, env_1.getGlobal)(function (g) { return (g.Wix && g.Wix.Utils && g.Wix.Utils.commonConfig) || g.commonConfig; });
};
var getCommonConfigValue = function (key, commonConfig) {
    if (commonConfig === void 0) { commonConfig = resolveCommonConfig(); }
    commonConfig =
        commonConfig && typeof commonConfig.getAll === 'function'
            ? commonConfig.getAll()
            : commonConfig;
    if (!commonConfig || typeof commonConfig[key] === 'undefined') {
        return constants_1.DefaultCommonConfig[key];
    }
    return commonConfig[key];
};
exports.getCommonConfigValue = getCommonConfigValue;
var getBrand = function (commonConfigGetter) {
    return (0, exports.getCommonConfigValue)('brand', commonConfigGetter());
};
exports.getBrand = getBrand;
var getBranchId = function (commonConfigGetter) {
    return (0, exports.getCommonConfigValue)('branchId', commonConfigGetter());
};
exports.getBranchId = getBranchId;
//# sourceMappingURL=common-config.js.map